// extracted by mini-css-extract-plugin
module.exports = {"slides":"style_slides__rDBCL","iframe":"style_iframe__QQiP3"};